import React, { useState, useEffect } from 'react';
import { Table, Button, message } from 'antd';
import { EyeOutlined, CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import ManageFaq from './ManageFaq';
import { useNavigate } from 'react-router-dom';

interface FaqData{
    faqId:string;
    faqQuestion:string;
    faqAnswer: string;
    isActive:string;
    createdDate:boolean;
    createdBy:string;
    updatedDate:string;
    updatedBy:string;
}

const DisplayFaq: React.FC = () => {
  const [faqData, setFaqData] = useState<FaqData[]>([]);
  const [isAddFaqVisible, setIsAddFaqVisible] = useState(false);
  const [isEditFaqVisible, setIsEditFaqVisible] = useState('');
  const { instance, accounts } = useMsal();
  const [selectedFaqId, setSelectedFaqId] = useState<string | null>(null); // Add this state

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
      }, []);

      useEffect(() => {
        getFaqData();
      }, [isAddFaqVisible]);

      const userId = localStorage.getItem("UserId");

      const getFaqData = async () => {
        try {
          const token = await fetchToken();
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Faq/GetAllFaqData/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          setFaqData(response.data);
        } catch (error) {
          console.error("Error fetching faq details", error);
        }
      };

      const handleEditFaqData = async (faqId: string) => {
        setSelectedFaqId(faqId); // Set the selected faqId
        setIsAddFaqVisible(true);
        
      };

      const handleDeleteFaqData = async (faqId: string) => {
        const confirmed = window.confirm('Are you sure you want to delete this item?');
        if(confirmed){
          try {
            const token = await fetchToken();
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Faq/DeleteFaqData`, 
              null,
            {
              params:{
                faq_id: faqId,
                user_id: userId
              },
              headers: {
                Authorization: `Bearer ${token}`
              }
            });
            message.success('FAQ data deleted successfully');
            getFaqData();
          } catch (error) {
            console.error("Error deleting details", error);
          }
        }
      };

      const columns = [
          {
            title: 'FAQ Question',
            dataIndex: 'faqQuestion',
            key: 'faqQuestion',
            // Custom render to allow wrapping
            render: (text: string) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{text}</div>
            ),
          },
          {
            title: 'FAQ Answer',
            dataIndex: 'faqAnswer',
            key: 'faqAnswer',
            // Custom render to allow wrapping
            render: (text: string) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{text}</div>
            ),
          },
          {
            title: 'FAQ Short Name',
            dataIndex: 'faqShortName',
            key: 'faqShortName',
            // Custom render to allow wrapping
            render: (text: string) => (
              <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                {text && text.trim() !== '' ? text : 'NA'}
              </div>
            ),
          },
          {
            title: 'Short Name Visible',
            dataIndex: 'isShortNameVisible',
            key: 'isShortNameVisible',
            // Custom render to allow wrapping
            render: (value: any) => (
              <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                {value === true || value === 'true' ? 'Yes' : 'No'}
              </div>
            ),
          },
          {
            title: 'Actions', // This is the column header
            key: 'actions',
            render: (_: any, record: FaqData) => (
            <div style={{ display: 'flex', gap: '8px' }}>
            <Button
                icon={<EditOutlined />}
                style={{ color: 'white', backgroundColor: '#1890ff', borderColor: '#1890ff' }}
                onClick={() => handleEditFaqData(record.faqId)}
            >
                Edit
            </Button>

            <Button
                icon={<DeleteOutlined />}
                style={{ color: 'white', backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
                onClick={() => handleDeleteFaqData(record.faqId)}
            >
                Delete
            </Button>
            </div>
            ),
        }
        ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
              <Button type="primary" onClick={() => setIsAddFaqVisible(false)} style={{ marginRight: 8 }}>
                View FAQ
              </Button>
              <Button type="primary" onClick={() => {
                setIsAddFaqVisible(true);
                setIsEditFaqVisible('');
                setSelectedFaqId(null);
              }} style={{ marginRight: 8 }}>
                Add FAQ
              </Button>
      </div>
              {isAddFaqVisible ? (<ManageFaq faqId = {selectedFaqId} />) : (<Table dataSource={faqData} columns={columns} rowKey="faqId" />)}
    </div>
  );
};

export default DisplayFaq;